import { Controller } from "@hotwired/stimulus";
import hljs from "highlight.js";
import 'highlight.js/styles/tokyo-night-light.css';
import javascript from 'highlight.js/lib/languages/javascript';
import ruby from 'highlight.js/lib/languages/ruby';
import bash from 'highlight.js/lib/languages/bash';
import swift from 'highlight.js/lib/languages/swift';
import xml from 'highlight.js/lib/languages/xml';
import kotlin from 'highlight.js/lib/languages/kotlin';

export default class extends Controller {

  initialize() {
    hljs.registerLanguage('javascript', javascript);
    hljs.registerLanguage('swift', swift);
    hljs.registerLanguage('ruby', ruby);
    hljs.registerLanguage('bash', bash);
    hljs.registerLanguage('xml', xml);
    hljs.registerLanguage('kotlin', kotlin);
  }

  connect() {
    hljs.highlightAll();
  }
}

